/** Pure helpers for the tenant and organization screens. No services. */

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Lowercase letters and digits, single hyphens between them. */
export function isValidSlug(value: string): boolean {
  return SLUG_PATTERN.test(value);
}

/** A slug derived from a name, so nobody has to invent one. */
export function slugFromName(name: string): string {
  return name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function displayName(record: { name: string | null; slug?: string | null }): string {
  return record.name || record.slug || 'Unnamed';
}

/** Records whose name, slug or app-api id contains the search, case-blind. */
export function matchesSearch(
  record: { name: string | null; slug: string | null; extAppApiId: string | null },
  search: string,
): boolean {
  const needle = search.trim().toLowerCase();
  return (
    !needle ||
    [record.name, record.slug, record.extAppApiId].some((value) =>
      value?.toLowerCase().includes(needle),
    )
  );
}

/** By display name, then id, so equal names keep a stable order. */
export function sortByName<T extends { id: string; name: string | null; slug?: string | null }>(
  records: readonly T[],
): T[] {
  return [...records].sort(
    (a, b) => displayName(a).localeCompare(displayName(b)) || a.id.localeCompare(b.id),
  );
}

export function tenantCount(count: number): string {
  return count === 1 ? '1 tenant' : `${count} tenants`;
}
